<template>
  <router-link :to="node.to" :title="node.title" class="nav-link">
    <icon-component :name="node.icon" @click="menuToggle($event)" />
    <p class="nav-title" @click="toggle($event)">
      {{ node.title }}
      <svg
        :style="{
          transform: expandedList ? 'rotate(180deg)' : 'rotate(360deg)'
        }"
        v-if="node.items.length"
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.4375 7.625L0.65625 2.84375C0.492188 2.67969 0.410156 2.48047 0.410156 2.24609C0.410156 2.01172 0.492188 1.8125 0.65625 1.64844L1.46484 0.875C1.62891 0.710938 1.82812 0.628906 2.0625 0.628906C2.29688 0.628906 2.49609 0.710938 2.66016 0.875L6.03516 4.25L9.41016 0.875C9.57422 0.710938 9.77344 0.628906 10.0078 0.628906C10.2422 0.628906 10.4414 0.710938 10.6055 0.875L11.4141 1.64844C11.5781 1.8125 11.6602 2.01172 11.6602 2.24609C11.6602 2.48047 11.5781 2.67969 11.4141 2.84375L6.63281 7.625C6.46875 7.78906 6.26953 7.87109 6.03516 7.87109C5.80078 7.87109 5.60156 7.78906 5.4375 7.625Z"
          fill="#ABABB3"
        />
      </svg>
    </p>
  </router-link>
  <ul
    v-if="hasChildren()"
    v-show="!getMenuState && expanded"
    class="nav nav-pills nav-sidebar flex-column nav-submenu"
  >
    <li v-for="item in node.items" :key="item.title">
      <tree-node :node="item"></tree-node>
    </li>
  </ul>
</template>

<script>
import IconComponent from "./IconComponent";

export default {
  name: "TreeNode",
  components: { IconComponent },
  props: {
    node: Object,
    showMenu: Boolean,
    index: Number
  },
  data() {
    return {
      expanded: false,
      expandedList: false
    };
  },
  mounted() {
    this.stateExpanded();
  },

  methods: {
    stateExpanded() {
      if (!this.$route.path.split("/").includes("admin") && this.showMenu)
        return (this.expanded = false);
    },
    menuToggle() {
      if (this.hasChildren()) {
        this.$store.dispatch("toggleMenuState");
        this.expanded = true;
      } else {
        this.expanded = false;
      }
    },
    hasChildren() {
      return this.node.items?.length;
    },

    toggle(e) {
      if (this.hasChildren()) {
        this.expandedList = !this.expandedList;
        e.preventDefault();
        this.expanded = !this.expanded;

        // this.saveState();
        return false;
      }
      this.stateExpanded();
      return true;
    }
    // loadState() {
    //     // //const expanded = localStorage.getItem(this.getKey());
    //     // if (!expanded) {
    //     //   return;
    //     // }
    //     // this.expanded = (expanded === 'true');
    //     this.stateExpanded()
    // },
    // // saveState() {
    // //   localStorage.setItem(this.getKey(), this.expanded);
    // // },
    // // getKey() {
    // //   return `tree-node:${this.node.to}`;
    // // }
  },
  watch: {
    showMenu: {
      handler() {
        this.stateExpanded();
      },
      deep: true
    }
  },
  computed: {
    getMenuState() {
      return this.$store.getters.getMenuState;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.active {
  color: $blue-dark !important;
}

.nav-pills {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 48px;

  .nav-item {
    max-width: 48px;
  }

  .nav-title {
    display: flex;
    align-items: baseline;
    justify-content: space-between;

    svg {
      width: 24px;
      height: 8px;
    }
  }

  .nav-link {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-weight: 600;
    font-size: 16px;
    line-height: 1.2;
    color: $gray-medium;

    .icon {
      color: $gray-medium;
      padding-right: 16px;
    }

    &.router-link-active {
      color: $blue-dark;
    }
  }
}

.dashboard-sidebar_collapsed {
  .nav-link {
    .icon {
      color: $white;
      padding: 0;
    }

    &.router-link-active {
      color: $blue-light;
      width: 48px;
      height: 48px;
      background-color: $blue-light;
    }
  }
}

.nav-pills.nav-submenu {
  margin-left: 10px;
  margin-top: 10px;

  .nav-title {
    min-width: 150px !important;
    white-space: normal !important;
    width: 100% !important;
  }
}

.nav-link {
  svg {
    position: absolute;
    left: 220px;
    margin-top: 5px;
      // top: 14px;
  }
}
</style>
